<template>
  <a
    class="message-location"
    :href="data.href"
    target="_blank"
    :title="TUITranslateService.t('AIDesk.跳转')"
  >
    <span class="el-icon-location-outline">{{ data.description }}</span>
    <img :src="data.url">
  </a>
</template>

<script lang="ts">
import { TUITranslateService } from '../../../../@aidesk/uikit-engine';
import vue from '../../../../adapter-vue';
const __sfc_main = {};
__sfc_main.props = {
  content: {
    type: Object,
    default: () => ({})
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const {
    watchEffect,
    ref
  } = vue;
  const props = __props;
  const data = ref();
  watchEffect(() => {
    data.value = props.content;
  });
  return {
    TUITranslateService,
    data
  };
};
export default __sfc_main;
</script>
<style lang="scss" scoped>
@import "../../style/common";

.message-location {
  display: flex;
  flex-direction: column;
}
</style>
